/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('MessageSend', function($scope, mailboxService, $rootScope, $http, _$privileges) {
    $scope.showLoader = false;
    $scope.rows = [];
    $rootScope.checkboxList.clear();

    $scope.data = {
        "can_write": _$privileges.write("message"),
        "sended": []
    };

    /*
     * pagination
     */

    $scope.pagination = {
        currentPage: 1,
        totalItems: 1,
        itemsPerPage: 1
    };

    $scope.setPage = function() {
        $scope.list($scope.pagination.currentPage);
    };

    $scope.list = function(page) {
        $scope.showLoader = true;       
        var filter = {
            "notification_category_id": $scope.search.filter.notification_category_id.value != null ? $scope.search.filter.notification_category_id.value.join() : "",
            "notification_id": $scope.search.filter.notification_id.value != null ? $scope.search.filter.notification_id.value.join() : "",
            "send_date_above": $scope.search.filter.send_date_from.value,
            "send_date_below": $scope.search.filter.send_date_to.value,
            "created_user": $scope.search.filter.user.value,
            "sended": $scope.search.filter.sended.value,
            "language": $scope.search.filter.language!= null ? $scope.search.filter.language.value.join() : ""
        };
        var promise = mailboxService.send(page, filter);
        promise.then(
            function(payload) {
                $scope.showLoader = false;
                $scope.data.mobile_notification_id = payload.data.mobile_notification_id;
                $scope.rows = payload.data.list.data;
                $scope.data.sended = payload.data.sended;
                $scope.pagination = {
                    totalItems: payload.data.list.total,
                    currentPage: payload.data.list.current_page,
                    itemsPerPage: payload.data.list.per_page
                };
            },
            function(errorPayload) {
                $rootScope.notification.show('error', 'Błąd ładowania wiadomości roboczych');
            });
    };

    $scope.search = {
        "data": {},
        "get": function() {
            $scope.showLoader = true;
            var promise = mailboxService.filter();
            promise.then(
                function(payload) {
                    $scope.showLoader = false;
                    $scope.search.data = payload.data;
                },
                function(errorPayload) {
                    $rootScope.notification.show('error', 'Błąd ładowania filtrów wyszukiwania skrzynki wiadomości');
                });
        },
        "filter": {
            "notification_category_id": {
                value: []
            },
            "mailbox_state_id": {
                value: []
            },
            "notification_id": {
                value: []
            },
            "user": {
                value: "",
            },
            "sended": {
                value: "",
                options: [{
                    label: "Wszystkie",
                    value: ""
                }, {
                    label: "W trakcie realizacji",
                    value: 0
                }, {
                    label: "Wysłana",
                    value: 1
                }]
            },
            "send_date_from": {
                value: ""
            },
            "send_date_to": {
                value: ""
            },
            "language": {
              value: []
            }
        }
    };

    $scope.list(1);
    $scope.search.get();

    $scope.onFilter = function() {

    };

    $scope.queryAssign = function(search) {
        return $http.get("/user?search=" + search).then(function(results) {
            return results.data;
        });
    };

    $scope.panel = {
        "show": function() {

        },
        "concate": function() {
            var ids = [];
            for (var i = 0; i < $scope.rows.length; i++) {
                if ($scope.rows[i].checked)
                    ids.push($scope.rows[i].id);
            }
            return ids;
        },
        "sendagain": function() {
            var promise = mailboxService.sendagain($scope.panel.concate()[0]);
            promise.then(
                function(payload) {
                    if(payload.data.code == 1){
                      $rootScope.notification.show('success',payload.data.msg);
                      $scope.list(1);
                      $rootScope.checkboxList.clear();
                    }else{
                      $rootScope.notification.show('error', payload.data.msg);
                    }

                },
                function(errorPayload) {
                    $rootScope.notification.show('error', 'Błąd ładowania wiadomości roboczych');
                });
        },
        "delete": function() {
            var promise = mailboxService.delete($scope.panel.concate());
            promise.then(
                function(payload) {
                    if (payload.data.code == 1) {
                        $rootScope.notification.show('success', payload.data.msg);
                        $scope.list(1);
                        $rootScope.checkboxList.clear();
                    } else {
                        $rootScope.notification.show('error', payload.data.msg);
                    }
                },
                function(errorPayload) {
                    $rootScope.notification.show('error', 'Wystąpił błąd podczas próby usunięcia wiadomości');
                });
        }
    };

    $scope.clearFilters = function() {
        $scope.search.filter.notification_category_id.value = [];
        $scope.search.filter.mailbox_state_id.value = [];
        $scope.search.filter.notification_id.value = []
        $scope.search.filter.user.value = "";
        $scope.search.filter.sended.value = "";
        $scope.search.filter.send_date_from.value = "";
        $scope.search.filter.send_date_to.value = "";
        $scope.search.filter.language.value = "";
        $scope.list(1);
    };

    $scope.checkForSend = function(row) {
        var data = new Date();
        var month = data.getMonth() + 1;
        month = month < 10 ? "0" + month : month;
        var dataString = data.getFullYear() + "-" + month + "-" + data.getDate();

        return $scope.data.sended[row.id] == 1 && !_.isUndefined(row.mobile_available) && row.mobile_available != null && dataString <= row.mobile_available ? 0 : 1;
    };
});
